import { ChakraProvider } from '@chakra-ui/react'
import React from 'react'
import { AlertCenterProvider } from '../components/Alert/AlertCenter'
import { theme } from '../theme'
import Fonts from './Fonts'

interface ApexUIProviderProps {
  children: React.ReactNode | React.ReactNode[]
}

const ApexUIProvider = ({ children }: ApexUIProviderProps) => (
  <ChakraProvider theme={theme}>
    <AlertCenterProvider>
      <Fonts />
      {children}
    </AlertCenterProvider>
  </ChakraProvider>
)

export default ApexUIProvider
